export default __webpack_public_path__ + "static/media/fa-regular-400.baaf04fd.svg";